import React from "react";


const Avatar = () =>{
  return <div className="TB">TB</div>
}

export default Avatar;